module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.1f14b582.png";